module.exports = __webpack_public_path__ + "img/vr_spiel1.9b8622eb.jpg";